// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeForServiceVM  {
    _originalTypeClassName = "Loom.BO.EmployeeForServiceVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeForServiceVM.translate = translateService;
}
this.lastname = null;
this.firstname = null;
this.callname = null;
this.AFM = null;
this.DOY = null;
this.phone = null;
this.mobile = null;
this.email = null;
this.personal_email = null;
this.position = null;
this.alpha_bank_account = null;
this.net_salary = null;
this.gross_salary = null;
this.org = null;
this.start_date = null;
this.end_date = null;
this.contract_end_date = null;
this.rate = null;
this.birthdate = null;
this.based_in_country = null;
this.employment_type = null;
this.weekly_hours = null;
this.max_monthy_hours = null;
this.max_annual_hours = null;
this._key = this.AFM = ""; 
}

static translate: TranslateService;
_key: any;
lastname:any;
firstname:any;
callname:any;
private _AFM:any;
get AFM(): any {
    return this._AFM;
  }
set AFM(value: any) {
    this._AFM = value;
    this._key = value;
  }
DOY:any;
phone:any;
mobile:any;
email:any;
personal_email:any;
position:any;
alpha_bank_account:any;
net_salary:any;
gross_salary:any;
org:any;
start_date:any;
end_date:any;
contract_end_date:any;
rate:any;
birthdate:any;
based_in_country:any;
employment_type:any;
weekly_hours:any;
max_monthy_hours:any;
max_annual_hours:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AFM == null || $this.AFM == "";
            }


}